import React from "react";

const WorkOrderPrintLayout = ({
  workOrderDetails,
  comments,
  selectedAssignee,
  selectedPriority,
  workOrderTypes,
  workOrderSubtypes,
  workOrderLocations,
  selectedTypeId,
  selectedSubtypeId,
  selectedLocationId,
  member, // ✅ member included
}) => {
  return (
    <div className="print-container">
      <h1 className="print-title">Work Order Summary</h1>

      {/* 🔹 Member Info Section */}
      {member && (
        <section className="member-section">
  <h2>Member Information</h2>
  <div className="workorder-details-horizontal">
    <div>
      <strong>Name:</strong> {member.FirstName} {member.LastName}
    </div>
    <div>
      <strong>Member #:</strong> {member.ClubMemberCode || "N/A"}
    </div>

    <div>
      <strong>Join Date:</strong>{" "}
      {member.JoinDate
        ? new Date(member.JoinDate).toLocaleDateString()
        : "N/A"}
    </div>
    <div className="email">
      <strong>Email:</strong> {member.EmailAddress || "N/A"}
    </div>

    {/* 🔹 Full width Address */}
    <div className="full-row">
      <strong>Address:</strong> {member.FullAddress || "N/A"}
    </div>
  </div>

  {/* 🔹 Phones on one clean row */}
  <div className="phone-row">
    <div><strong>Phone:</strong> {member.PhoneNumber || "N/A"}</div>
    <div><strong>Alt Phone:</strong> {member.AlternatePhoneNumber || "N/A"}</div>
    <div><strong>Cell:</strong> {member.CellPhoneNumber || "N/A"}</div>
  </div>
</section>
      )}

      <hr className="divider" />

      {/* 🔹 Work Order Info */}
      <section className="workorder-section">
        <h2>Work Order #{workOrderDetails?.order_id}</h2>
        <div className="workorder-details-horizontal">
          <div><strong>Status:</strong> {workOrderDetails?.status}</div>
          <div><strong>Assignee:</strong> {selectedAssignee?.name || "N/A"}</div>
          <div><strong>Priority:</strong> {selectedPriority || "N/A"}</div>
          <div>
            <strong>Type:</strong>{" "}
            {workOrderTypes.find((t) => t.id === selectedTypeId)?.type || "N/A"}
          </div>
          <div>
            <strong>Subtype:</strong>{" "}
            {workOrderSubtypes.find((s) => s.id === selectedSubtypeId)?.subtype_name || "N/A"}
          </div>
          <div>
            <strong>Location:</strong>{" "}
            {workOrderLocations.find((l) => l.id === selectedLocationId)?.location_name || "N/A"}
          </div>
          <div>
            <strong>Created At:</strong>{" "}
            {workOrderDetails?.created_at
              ? new Date(workOrderDetails.created_at).toLocaleString()
              : "N/A"}
          </div>
        </div>

        <p><strong>Description:</strong></p>
        <blockquote>{workOrderDetails?.description || "N/A"}</blockquote>
      </section>

      <hr className="divider" />

      {/* 🔹 Comments */}
      <section className="comments-section">
        <h3>💬 Comments</h3>
        {comments.length === 0 ? (
          <p>No comments recorded.</p>
        ) : (
          comments.map((c) => (
            <div key={c.comment_id} className="comment-block">
              <div className="comment-header">
                <span className="comment-author">
                  <strong>{c.user_name} {c.user_lastname}</strong>
                </span>
                <span className="comment-date">
                  {new Date(c.sent_at).toLocaleString()}
                </span>
              </div>
              <blockquote className="comment-body">{c.comment_text}</blockquote>
            </div>
          ))
        )}
      </section>

      <hr className="divider" />

      <div className="print-footer">
        Printed on {new Date().toLocaleString()} — My HOA Management System
      </div>
    </div>
  );
};

export default WorkOrderPrintLayout;
